<template>
    <div v-if="settings.show">
        <div class="popupModal" :class="{active: showLogInModal}">
            <pageLoader :showLoader='showLoader'></pageLoader>
            <div class="loginModal__wrapper" @click="underlayClick">
                <div class="loginModal__content" id="popupModal__content2">
                    <div class="logIn-top__wrapper">
                        <div class="fields_wrapper">
                            <div class="field_item">{{this.pinData['0']}}</div>
                            <div class="field_item">{{this.pinData['1']}}</div>
                            <div class="field_item">{{this.pinData['2']}}</div>
                            <div class="field_item">{{this.pinData['3']}}</div>
                        </div>
                        <div class="logIn-bottom__wrapper">
                            <div class="number_buttons">
                                <span class="number_button" @click="onNumberBtnClick(7)">7</span>
                                <span class="number_button" @click="onNumberBtnClick(8)">8</span>
                                <span class="number_button" @click="onNumberBtnClick(9)">9</span>
                                <span class="number_button" @click="onNumberBtnClick(4)">4</span>
                                <span class="number_button" @click="onNumberBtnClick(5)">5</span>
                                <span class="number_button" @click="onNumberBtnClick(6)">6</span>
                                <span class="number_button" @click="onNumberBtnClick(1)">1</span>
                                <span class="number_button" @click="onNumberBtnClick(2)">2</span>
                                <span class="number_button" @click="onNumberBtnClick(3)">3</span>
                                <span class="number_button_empty"></span>
                                <span class="number_button" @click="onNumberBtnClick(0)">0</span>
                                <div class="number_button" @click="onClearNumberBtnClick()"><img src="@/assets/icons/ic_backspace.svg"></div>
                            </div>
                            <div class="input-btn__wrapper" v-if="false">
                                <a class="sign-in__button">{{ translate('signIn_signInBtn') }}</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import logAnalyticsEvent, {logError} from '@/helpers/analytics'
import rateMixin from '@/mixins/rateMixin';
import {mapActions, mapGetters} from 'vuex';
import navMixin from "@/mixins/navMixin";
import errorMixin from "@/mixins/errorMixin";
import pageLoader from "./pageLoader";

export default {
    name: "staffLogInModal",
    mixins: [mixin, rateMixin, navMixin, errorMixin],
    components: {
        pageLoader,
    },
    data() {
        return {
            showLogInModal: this.settings !== null,
            pinData: {0: '', 1: '', 2: '', 3: '',},
            showLoader: false,
        }
    },
    watch: {
        settings(newValue) {
            this.showLogInModal = newValue !== null
        },
    },
    props: {
        settings: {
            type: [Object, null],
            default: () => {
                return {}
            }
        },
    },
    computed: {
        ...mapGetters({
            isAuthorized: 'auth/isAuthorized',
        }),
    },
    methods: {
        ...mapActions({
            pinLogIn: 'auth/pinLogIn',
            fetchUserInfo: 'auth/fetchUserInfo',
        }),
        async onFacebookSignIn() {
            logAnalyticsEvent(`signin_loginfb`)
            await this.FacebookSignIn({
                becomeOwner: false,
                redirect: false
            })

            if (this.isAuthorized) {
                await this.onGotUserCreds()
            }
        },
        async logInPin() {
            logAnalyticsEvent(`login_pin_try`)
            let pinValue = this.pinData[0] + this.pinData[1] + this.pinData[2] + this.pinData[3]
            const body = {
                pin: pinValue,
                question_uid: this.settings.question_uid,
            }
            this.applyLoader(true)
            try {
                const response = await this.pinLogIn(body)
                if (response.data.access_token && response.data.refresh_token) {
                    this.setSignInState(response)
                    // await this.tryChangeUserStatus()
                    logAnalyticsEvent(`login_pin_success`)
                    await this.onGotUserCreds()
                }
            } catch (e) {
                logError('login_pin_error', e.data.error.message || '')
                this.pinData[0] = ''
                this.pinData[1] = ''
                this.pinData[2] = ''
                this.pinData[3] = ''
                this.showErrorModal(e.data.error.message, {
                    title: 'Error',
                    code: e.data.error.code
                })
            } finally {
                this.applyLoader(false)
            }
        },
        applyLoader(show) {
            this.showLoader = show
        },
        async onGotUserCreds() {
            await this.fetchUserInfo()
            this.showLogInModal = false
            this.settings.onGotUserCreds()
        },
        underlayClick(e) {
            if (this.isClickOutOfBlock('popupModal__content2', e.target) && this.settings.hideOnClickOutside) {
                this.showLogInModal = false
            }
        },

        onClearNumberBtnClick(value) {
            if (this.pinData[3] != '') {
                this.pinData[3] = ''
            } else if (this.pinData[2] != '') {
                this.pinData[2] = ''
            } else if (this.pinData[1] != '') {
                this.pinData[1] = ''
            } else if (this.pinData[0] != '') {
                this.pinData[0] = ''
            }
        },

        onNumberBtnClick(value) {
            let str = '' + value
            if (this.pinData[0] == '') {
                this.pinData[0] = str
            } else if (this.pinData[1] == '') {
                this.pinData[1] = str
            } else if (this.pinData[2] == '') {
                this.pinData[2] = str
            } else if (this.pinData[3] == '') {
                this.pinData[3] = str
                this.logInPin()
            }
        },
    },
}
</script>

<style scoped>

.loginModal__content {
    margin-top: 160px;
}

.logIn-top__wrapper {
    background-color: #32324B;
    border-radius: 16px 16px 16px 16px;
}

.logIn-bottom__wrapper {
    background-color: #3F405C;
    border-radius: 0 0 16px 16px;
    padding-bottom: 32px;
}

input {
    outline: none;
    color: white;
    border: none;
    background-color: #3F405C;
    border-radius: 0;
}

input::-webkit-input-placeholder {
    color: #FFFFFF;
    font-family: Nunito;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    letter-spacing: 0;
    line-height: 24px;
    opacity: 0.7;
}


.input-btn__wrapper {
    display: flex;
    flex-direction: column;
}

.sign-in__button {
    color: #2F2F2F;
    font-family: Nunito;
    font-size: 16px;
    font-weight: 700;
    letter-spacing: 0;
    line-height: 24px;
    text-align: center;
    border-radius: 6px;
    background-color: #FFBF00;
    box-shadow: 0 2px 8px 0 #FFBF00;
    padding: 12px;
    margin-left: 24px;
    margin-right: 24px;
    margin-bottom: 24px;
}

.fields_wrapper {
    margin-top: 25px;
    padding-bottom: 24px;
    display: flex;
    flex-direction: row;
    justify-content: center;
}

.field_item {
    width: 40px;
    height: 30px;
    padding-top: 12px;
    color: #FFFFFF;
    margin-left: 4px;
    border-bottom: 3px solid #ffffff;
    background: #3F405C;
    font-family: Nunito;
    font-size: 28px;
    font-weight: 700;
    letter-spacing: 0;
    line-height: 24px;
    padding-bottom: 5px;
    text-align: center;
}

.number_buttons {
    padding-top: 32px;
    display: flex;
    flex-wrap: wrap;
    flex: 0 1 100%;
    justify-content: center
}

.number_button {
    display: flex;
    flex: 0 1 25%;
    justify-content: center;
    align-items: center;
    color: #3F405C;
    height: 50px;
    border: 1px solid #3F405C;
    border-top: none;
    border-left: none;
    cursor: pointer;
    background: -webkit-linear-gradient(top, #ffffff, #ffffff);
    font-size: 2em;
}

.number_button:active {
    background: #e8e8e8;
}

.number_button.small {
    height: 40px;
}

.number_button_empty {
    display: flex;
    flex: 0 1 25%;
    border: 1px solid #3F405C;
    border-top: none;
    border-left: none;
    cursor: none;
}

.page-loader {
    pointer-events: all;
    z-index: 999999999;
}

</style>